import * as $ from 'jquery';
import  colorComponentJS  from  './color-cardjs.js'

export class ColorsCommon {

    static init() {
        $('.color-card-component').each(function() {
            colorComponentJS.init($(this));
        });
    }
} 